import { storage } from '@/Services/Storage'
import { auth as Auth } from '@/Services/Axios'
import router from '@/Router'

export const auth = {
    namespaced: true,
    state: {
        user: null,
        token: null,
        isRefreshing: false,
        unauthorizedPermissions: [],
    },
    getters: {
        getUser(state) {
            return state.user
        },
        getToken(state) {
            return state.token
        },
        getUnauthorizedPermissions(state) {
            return state.unauthorizedPermissions
        },
    },
    mutations: {
        SET_USER(state, payload) {
            state.user = payload
        },
        SET_TOKEN(state, payload) {
            state.token = payload
        },
        SET_IS_REFRESHING(state, payload) {
            state.isRefreshing = payload
        },
        SET_UNAUTHORIZED_PERMISSION(state, payload) {
            if (!state.unauthorizedPermissions.includes(payload)) state.unauthorizedPermissions.push(payload)
        },
        CLEAR_UNAUTHORIZED_PERMISSIONS(state) {
            state.unauthorizedPermissions = []
        },
    },
    actions: {
        /**
         * Action que seta os dados do usuário logado no state
         */
        setUser({ commit }, payload) {
            commit('SET_USER', payload)
        },

        /**
         * Action que seta o token JWT no state
         */
        setToken({ commit }, payload) {
            commit('SET_TOKEN', payload)
        },

        /**
         * Action que define no state de o processo de refresh do token JWT está
         * sendo efetuado
         */
        setIsRefreshing({ commit }, payload) {
            commit('SET_IS_REFRESHING', payload)
        },

        /**
         * Action que seta no state uma nova permissão à qual o usuário logado não possui
         */
        setUnauthorizedPermission({ commit }, payload) {
            commit('SET_UNAUTHORIZED_PERMISSION', payload)
        },

        /**
         * Action que remove do state as informações referentes as permissões que o
         * usuário logado não possui
         */
        clearUnauthorizedPermissions({ commit }) {
            commit('CLEAR_UNAUTHORIZED_PERMISSIONS')
        },

        /**
         * Realiza o processo de login
         *
         * @param {*} dispatch
         * @param {*} data
         */
        async doLogin({ dispatch }, data) {
            const getToken = await Auth.login(data)
            const userToken = getToken.data['token']
            // const user = await User.me(userToken)

            // if (user.data.status == 'inactive') {
            //     router.push({
            //         name: 'message',
            //         params: {
            //             title: 'Acesso Bloqueado.',
            //             text:
            //                 user.data.user_group === 'user' && storage.get('user_approve') === 'active'
            //                     ? 'O seu perfil está em análise. Você receberá um e-mail quando for aprovado.'
            //                     : 'O seu acesso está bloqueado temporariamente.',
            //             icon: 'fal fa-lock-alt',
            //             type: 'default  ',
            //             btnUrl: '/',
            //             btnText: 'Tentar mais tarde',
            //         },
            //     })
            //     return false
            // }

            /** Executa login no painel legado para criar sessão */
            await Auth.loginOk(data)

            dispatch('setToken', userToken)
            // dispatch('setUser', user.data)

            // if (!user.data.photo) {
            //     user.data.photo = 'no-avatar.png'
            // }

            // const userData = JSON.stringify(user.data)

            storage.set('user_token', userToken)
            // storage.set('user_logged', userData)

            router.push({ path: '/' })
        },

        /**
         * Seta os dados do usuário logado salvos no localStorage no store
         *
         * @param {*} dispatch
         */
        authExists({ dispatch }) {
            const user = storage.get('user_logged')
            const token = storage.get('user_token')

            if (!user) return false

            let userdata = JSON.parse(user)

            dispatch('setToken', token)
            dispatch('setUser', userdata)

            return true
        },

        /**
         * Limpa os dados do usuário do store e do localStorage
         *
         * @param {*} dispatch
         */
        clearUserData({ dispatch }) {
            dispatch('setUser', null)
            dispatch('setToken', '')
            storage.remove('user_logged')
            storage.remove('user_token')
            storage.remove('user_choice')
            router.push({ path: '/login' })
        },

        /**
         * Realiza logout do usuário
         *
         * @param {*} dispatch
         */
        async logout({ dispatch }) {
            const token = storage.get('user_token')
            await Auth.logout(token).then(() => {
                dispatch('clearUserData')
            })
        },

        /**
         * Realiza uma requisição para /me de modo a verificar se o token
         * salvo é válido
         *
         * @param {*} dispatch
         */
        async validatedToken({ dispatch }) {
            const token = storage.get('user_token')
            if (token) {
                try {
                    // await User.me(token)
                } catch (error) {
                    dispatch('clearUserData')
                }
            }
        },
    },
}
